import React, { useMemo, useState, useContext, useEffect, useRef } from 'react'
import List from './List';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { Filters } from '../../Dashboard/views/components/RentalDashboard';
import FleetManagerCarKPI from './FleetManagerCarKPI';
import RentalManagerCarKPI from './RentalManagerCarKPI';
import useFiltersFromLocation from 'src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation';
import JSONPretty from 'react-json-pretty';

const Default = () => {
    const { appConfiguration, userCapabilities } = useContext(AppContext);
    const [filtersFromLocation, setFiltersFromLocation] = useFiltersFromLocation();
    const [filtersFromTable, setFiltersFromTable] = useState();
    const [filters, setFilters] = useState();
    const [needTransmission, setNeedTransmission] = useState(false);
    const prev = useRef({});

    useEffect(() => {
        const timeout = setTimeout(() => {
            //console.info("Filters From Location", filtersFromLocation, [...(filtersFromLocation?.filterModel?.items ?? [])])
            //console.info("Filters from Table", filtersFromTable, [...(filtersFromTable ? filtersFromTable.map(({ id, fromInput, ...rest }) => rest) : [])]);

            const localFiltersFromTable = filtersFromTable
                ? filtersFromTable.map(({ id, fromInput, ...rest }) => rest)
                : [];

            const localFiltersFromLocation = filtersFromLocation?.filterModel?.items ?? [];

            let base, incoming, merged;

            if (JSON.stringify(prev.current.filtersFromLocation) !== JSON.stringify(localFiltersFromLocation)) {
                //console.info("cambiato filtersFromLocation", prev.current.filtersFromLocation, localFiltersFromLocation);

                base = localFiltersFromTable;
                incoming = localFiltersFromLocation;

                // aggiorno la copia locale dei filtri e la invio perché DataGrid la prenda in carico
                setNeedTransmission(true);
            } else if (JSON.stringify(prev.current.filtersFromTable) !== JSON.stringify(localFiltersFromTable)) {
                //console.info("cambiato filtersFromTable", prev.current.filtersFromTable, localFiltersFromTable);

                base = localFiltersFromLocation;
                incoming = localFiltersFromTable;

                // aggiorno la copia locale dei filtri ma non la reinvio perché DataGrid ha già fatto il suo
                setNeedTransmission(false);
            } else {
                setNeedTransmission(false);
                return;
            }

            merged = Object.values(
                [...base, ...incoming]
                    .filter(item => item.value !== "" && item.value !== undefined)
                    .reduce((acc, item) => {
                        acc[item.field] = item; // sovrascrive se field già presente
                        return acc;
                    }, {})
            );

            setFilters({
                filterModel: {
                    items: merged
                }
            });

            prev.current = { filtersFromLocation: localFiltersFromLocation, filtersFromTable: localFiltersFromTable };
        }, 500); // debounce di 500ms

        return () => clearTimeout(timeout);
    }, [filtersFromLocation, filtersFromTable]);


    return useMemo(() => <>
        {
            appConfiguration.dashboard.view == 'fleetmanager' &&
            <FleetManagerCarKPI filters={filtersFromLocation} setFilters={setFiltersFromLocation} userCapabilities={userCapabilities} />
        }
        {
            appConfiguration.dashboard.view == 'ConsecutionSales' &&
            <>
                <RentalManagerCarKPI filters={filters} setFilters={setFiltersFromLocation} userCapabilities={userCapabilities} />
                <Filters filters={filters} setFilters={setFiltersFromLocation} />
            </>
        }
        {
            needTransmission ?
                <List filters={filters} setFilters={setFiltersFromTable} /> :
                <List setFilters={setFiltersFromTable} />
        }

    </>, [filters])

}

export default Default;


